<script setup lang="ts">
import type { IReview } from '~/interfaces/reviews/IReview';
import { GLOBAL_PRODUCT_REVIEWS_DISPLAY_COMMENTS } from '~/plugins/featureFlag';
import ReviewStars from '~/components/reviews/review-stars.vue';
import { dateFromTimestamp } from '~/helpers/dates/dateHelper';
import { useProductStore } from '~/store/product/productStore';
import { MODAL_CLOSE, MODAL_OPEN, MODAL_REVIEW_RULES, useModalStore } from '~/store/modalStore';

const productStore = useProductStore();
const modalStore = useModalStore();

const {
  product
} = storeToRefs(productStore)

const locale = useI18n().locale
const props = defineProps<{
  globalRateCount: number
  latestReviews: IReview[]
}>()

const {
  latestReviews,
  globalRateCount
} = toRefs(props)

const getReviewSourceValue = (review: IReview, source: string = 'source') => {
  if (!review.reviewGuest) {
    return null
  }

  return review.reviewGuest.metadata[source];
}
</script>

<template>
  <section>
    <div class="mt-2 weight--interbold">
      {{ $t('www.partials.truspilot_widget.reviews') }} ({{ globalRateCount }})
      <svg
          class="ml-h cicon cicon--20 cicon--s-grey pointer"
          @click="modalStore.displayModal(MODAL_REVIEW_RULES, MODAL_OPEN);">
        <use xlink:href="#info"/>
      </svg>
    </div>
    <div
        v-for="(review, index) in latestReviews"
        :key="index"
        class="mt-2">
      <div class="df jcsb creviews__origin-comment">
        <div class="df jcsb creviews__w55">
          <div class=" mr-1">
            <span class="weight--intersbold">{{ review.user }} </span>
            <span class="size--subheadline">
              - <NuxtTime :datetime="dateFromTimestamp(review.createdAt)" year="numeric" month="numeric" day="numeric" :locale="locale" />
            </span>
          </div>
          <div class="df aic jcsb ">
            <review-stars :rate="review.rate" />
          </div>
        </div>
        <div v-if="review.reviewGuest" class="df c-grey-std size--subheadline">
          {{ $t('www.review.guest.source.0', {'source' : getReviewSourceValue(review)}) }}
        </div>
      </div>
      <div v-if="$isFeatureEnabled(GLOBAL_PRODUCT_REVIEWS_DISPLAY_COMMENTS)" class="df fww creviews__comment">{{ review.comment }}</div>
      <span class="weight--intermedium clink--grey size--button-3">
          {{ $t('www.review.purchased_at') }}
          <NuxtTime ref="nuxtTime" :datetime="dateFromTimestamp(review.purchasedAt)" year="numeric" month="numeric" day="numeric" :locale="locale" />
          &nbsp;|&nbsp;
      </span>
      <a target="_blank" :href="$customLocalePath('www_reviews_report', {id: review.id})" class="pb-1 clink clink--grey">
        {{ $t('www.review.report') }}
      </a>
    </div>
    <div v-if="globalRateCount > 5">
      <div class="mt-2 right-text">
        <a :href="$customLocalePath('www_product_reviews', {sport: product.sport, id: product.id, slug: product.slug})" class="size--headline weight--interregular underline-text">{{ $t('www.ratingblock.see_all_opinion') }}</a>
      </div>
    </div>
  </section>
</template>
